// extracted by mini-css-extract-plugin
export default {"budgetSlider":"Slider_budgetSlider__qvP98","customHandle":"Slider_customHandle__opApS","barWrapper":"Slider_barWrapper__AwmKH","bar":"Slider_bar__aP-mv"};